<template >
    <div>
        <vs-popup class="Change_petition_wrap cls-btn" title="Confirmation" v-if="showConfirmation" :active.sync="showConfirmation">
            <div class="Change_petition">
                <div class="form-container py-0">
                <div class="vx-row">
                    <div class="vx-col w-full">
                    <p class="text-left p-0">Are you sure continue?</p>
                    </div>
                </div>
                </div>
            </div>
            <div class="popup-footer">
                <vs-button color="dark" @click="redirectAnonymus()" class="cancel" type="filled">Without Login</vs-button>
                <vs-button color="success" @click="redirectToLogin()" class="save" type="filled">With Login</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>
export default {
    components: {
     
    },
    data() {
      return {
        isLoggedIn:false,
        petitionId:'',
        showConfirmation:false,
        anyToken:'',
        anonymusData:null,
      }
    },
    mounted() {
        this.petitionId = this.$route.params.itemId
        this.init();
    },
    computed:{
      
    },
    methods:{
        redirectAnonymus(){
            this.showConfirmation = false;
            const path = `/i9/fill-verifier-info/${this.petitionId}`;
            console.log(path)
            this.$router.push({
                path,
                query: {
                    token: this.anyToken,
                    joinMeet:'join'
                }
            })
        },
        redirectToLogin(){
            this.showConfirmation = false;
            this.$router.push({name:'page-login', params: { itemId: this.petitionId, type:'i9' }})
        },
        init(){
            let isLogged =this.$store.getters.isLoggedIn;
            console.log(isLogged, 'isLoggedINN')
            let currentRoute = this.$route;
            let token = '';
            if(_.get(currentRoute, "name", "") == "anonymous-meeting" &&  _.has(currentRoute, "meta.getTokenFromUrl") && _.has(currentRoute, "query.token") ) {
                token = _.get(currentRoute, "query.token", "");
                if(token){
                    this.anyToken = token;
                    let payLoad = { apiToken:token };
                    let path = '/auth/verify-token';
                    this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((res)=>{
                        console.log(JSON.stringify(res));
                        if(res){
                            this.anonymusData = res;
                            if(isLogged){
                                this.$router.push({ name: 'i9-details', params: { itemId: this.petitionId, joinMeet:'' } }).catch(err => {})
                            }else{
                                if([51,50,12].indexOf(res['roleId'])>-1){
                                    this.$router.push({name:'page-login', params: { itemId: this.petitionId, type:'i9' }})
                                }else if([49].indexOf(res['roleId'])>-1){
                                    if(res['userId']){
                                        this.showConfirmation = true;
                                    }else{
                                        this.redirectAnonymus();
                                    }
                                }else{
                                    this.$store.commit('updateAnonymousUserData', res)
                                }
                            }
                        }
                    }).catch((err)=>{})
                }
            }
        },
    }
};
</script>